
import { Component,OnInit } from '@angular/core';
import { ISystemStatus, SystemStatus } from './system-status';
import { ISystemInfo, SystemInfo } from './system-info';
import { ISystemLastHeartbeat, SystemLastHeartbeat } from './system-last-heart-beat';
import { ISystemRecentPoints, SystemRecentPoints } from './system-recent-points';
import { ISystemPointHistory, SystemPointHistory } from './system-point-history';
import { SystemHealthRetriever as SystemHealthRepository } from './system-health-retriever.service';
import { ApiResponse } from '../../models/api-response';
import { NotificationService } from "../../services/notification.service";
import { TenantRetrieverService } from "../../services/tenant-Retriever.service";

@Component({
    selector: "mainsystemhealth",
    template: require("./system-health-retriever.component.html")
})
export class SystemHealthComponent implements OnInit  {
    systemGuid: string;
    user: string;
    responseData: any;
    tenantName: string;
    tenantNameList: string[];
    errorInFetchingTenantNames: boolean = true;
    isSystemStatusRetrieved: boolean = false;
    isSystemInfoRetrieved: boolean = false;
    isSystemHeartbeatRetrieved: boolean = false;
    isPointHistoryRetrieved: boolean = false;
    isRecentPointsRetrieved: boolean = false;

    retrievedSystemStatus: ISystemStatus = new SystemStatus(false);
    retrievedSystemInfo: ISystemInfo = new SystemInfo(null, '', '', '');
    retrievedLastHeartbeat: ISystemLastHeartbeat = new SystemLastHeartbeat(null);
    retrievedPointHistory: ISystemPointHistory = new SystemPointHistory(false, null, null);
    retrievedRecentPoints: ISystemRecentPoints = new SystemRecentPoints(null);

    systemstatus: ISystemStatus[];
    systeminfo: ISystemInfo[];
    systemlastheartbeat: ISystemLastHeartbeat[];
    systempointhistory: ISystemPointHistory[];
    systemrecentpoints: ISystemRecentPoints[];

    guidValidatorRegex: RegExp = new RegExp('^[{(]?[0-9A-Fa-f]{8}[-]?([0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}[)}]?$');

    constructor(private systemHealthRepo: SystemHealthRepository,
        private notifier: NotificationService, private tenantRetriever: TenantRetrieverService) {
        this.notifier.clear();
    }

    ngOnInit(): void {
        this.getTenantNames();
    }

    getTenantNames() {
        this.notifier.displayInfo("Fetching Tenant Names ...");
        this.tenantRetriever.getTenant().subscribe(
            resp => {
                this.notifier.clear();
                this.responseData = resp;
                this.processGetTenantResponse();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            }
        );
    }

    processGetTenantResponse() {

        if (this.responseData.statusCode === 200) {
            this.tenantNameList = this.responseData.data;
            this.tenantName = this.tenantNameList[0];
            this.errorInFetchingTenantNames = false;
        } else {
            this.errorInFetchingTenantNames = true;
            this.notifier.displayError("Unable to fetch Tenant names");
        }
    }
    
    typeCastResponseStatus(response: any): ISystemStatus {

        if (response.statusCode === 200) {
            var retrievedSystemStatus = (<ISystemStatus>(<ApiResponse>(response)).data);
            this.isSystemStatusRetrieved = true;
            return retrievedSystemStatus;

        }
        this.notifier.displayError(response.data.value);
        return new SystemStatus(false);
    }

    typeCastResponseInfo(response: any): ISystemInfo {

        if (response.statusCode === 200) {
            this.isSystemInfoRetrieved = true;
            var retrievedSystemInfo = (<ISystemInfo>(<ApiResponse>(response)).data);
            return retrievedSystemInfo;

        }
        this.notifier.displayError(response.data.value);
        return new SystemInfo(null, '', '', '');
    }

    typeCastResponsePointHistory(response: any): ISystemPointHistory {

        if (response.statusCode === 200) {
            this.isPointHistoryRetrieved = true;
            var retreivedPointHistory = (<ISystemPointHistory>(<ApiResponse>(response)).data);
            return retreivedPointHistory;

        }
        this.notifier.displayError(response.data.value);
        return new SystemPointHistory(false,null,null);
    }
    
    typeCastResponseRecentPoints(response: any): ISystemRecentPoints {

        if (response.statusCode === 200) {
            this.isRecentPointsRetrieved = true;
            var retrievedRecentPoints = (<ISystemRecentPoints>(<ApiResponse>(response)).data);
            return retrievedRecentPoints;

        }
        this.notifier.displayError(response.data.value);
        return new SystemRecentPoints(null);
    }

    typeCastResponseLastHeartbeat(response: any): ISystemLastHeartbeat {

        if (response.statusCode === 200) {
            this.isSystemHeartbeatRetrieved = true;
            var retrievedLastHeartbeat = (<ISystemLastHeartbeat>(<ApiResponse>(response)).data);
            return retrievedLastHeartbeat;

        }
        this.notifier.displayError(response.data.value);
        return new SystemLastHeartbeat(null);
    }

    getsysteminformationByGuid() {
        this.isSystemInfoRetrieved = false;

        if (!this.guidValidatorRegex.test(this.systemGuid)) {
            this.notifier.displayError("Please enter a valid Guid");
            return;
        }
        this.notifier.displayInfo("Fetching system information..");
        this.systemHealthRepo.getsysteminformationByGuid(this.systemGuid,this.tenantName).subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData)
                    this.retrievedSystemInfo = this.typeCastResponseInfo(this.responseData);
                this.retrievedSystemInfo.systemTime = this.formatdate(this.retrievedSystemInfo.systemTime);
                this.notifier.clear();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            });
    }

    getlastheartbeatByGuid() {
        this.isSystemHeartbeatRetrieved = false;

        if (!this.guidValidatorRegex.test(this.systemGuid)) {
            this.notifier.displayError("Please enter a valid Guid");
            return;
        }
        this.notifier.displayInfo("Fetching last heartbeat..");
        this.systemHealthRepo.getlastheartbeatByGuid(this.systemGuid, this.tenantName).subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData)
                    this.retrievedLastHeartbeat = this.typeCastResponseLastHeartbeat(this.responseData);
                this.retrievedLastHeartbeat.systemTime = this.formatdate(this.retrievedLastHeartbeat.systemTime);
                this.notifier.clear();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            });

    }

    getsystemstatusByGuid() {
        this.isSystemStatusRetrieved = false;

        if (!this.guidValidatorRegex.test(this.systemGuid)) {
            this.notifier.displayError("Please enter a valid Guid");
            return;
        }
        this.notifier.displayInfo("Fetching last known status..");
        this.systemHealthRepo.getsystemonlinestatusByGuid(this.systemGuid, this.tenantName).subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData)
                    this.retrievedSystemStatus = this.typeCastResponseStatus(this.responseData);

                this.notifier.clear();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            });

    }

    getrecentpointsByGuid() {
        this.isRecentPointsRetrieved = false;

        if (!this.guidValidatorRegex.test(this.systemGuid)) {
            this.notifier.displayError("Please enter a valid Guid");
            return;
        }
        this.notifier.displayInfo("Fetching recent points..");
        this.systemHealthRepo.getrecentpointsByGuid(this.systemGuid, this.tenantName).subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData)
                    this.retrievedRecentPoints = this.typeCastResponseRecentPoints(this.responseData);
                this.retrievedRecentPoints.pointIds.toString();
                this.notifier.clear();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            });
    }

    getpointhistoryByGuid() {
        this.isPointHistoryRetrieved = false;

        if (!this.guidValidatorRegex.test(this.systemGuid)) {
            this.notifier.displayError("Please enter a valid Guid");
            return;
        }
        this.notifier.displayInfo("Fetching point history..");
        this.systemHealthRepo.getpointhistoryByGuid(this.systemGuid, this.tenantName).subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData)
                    this.retrievedPointHistory = this.typeCastResponsePointHistory(this.responseData);
                this.retrievedPointHistory.firstTimestamp = this.formatdate(this.retrievedPointHistory.firstTimestamp);
                this.retrievedPointHistory.lastTimestamp = this.formatdate(this.retrievedPointHistory.lastTimestamp);
                this.notifier.clear();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            });

    }

    formatdate(datetoformat: Date) {
       return new Date(Date.parse(datetoformat.toLocaleString()));
    }

    initializeCurrentTab() {
        this.notifier.clear();
        this.retrievedSystemInfo = new SystemInfo(null, '', '', '');
        this.retrievedLastHeartbeat = new SystemLastHeartbeat(null);
        this.retrievedSystemStatus = new SystemStatus(false);
        this.retrievedPointHistory = new SystemPointHistory(false, null, null);
        this.retrievedRecentPoints = new SystemRecentPoints(null);
        this.isSystemStatusRetrieved = false;
        this.isSystemInfoRetrieved = false;
        this.isSystemHeartbeatRetrieved = false;
        this.isPointHistoryRetrieved = false;
        this.isRecentPointsRetrieved = false;
    }

    encodeToBase64(id: string) {
        return btoa(id);
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/systemHealthRetriever/system-health-retriever.component.ts
 **/